
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesscopymachines/privacy-policy",
      function () {
        return require("private-next-pages/businesscopymachines/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesscopymachines/privacy-policy"])
      });
    }
  